export default __webpack_public_path__ + "static/media/delivery-bike.0a90db51.svg";